export default "__VITE_ASSET__Cnguuks5__"